/**
 * Client-side BotID (spam brief §4, level 1). initBotId adds BotID's
 * verification headers to these POSTs; the routes check them only for stores
 * at spam protection level 1 or higher (src/lib/botCheck.ts). Keep this list
 * equal to the routes that call isBotAtLevel.
 */
import { initBotId } from 'botid/client/core'

initBotId({
  protect: [
    { path: '/api/forms/submit', method: 'POST' },
    { path: '/api/bookings/checkout', method: 'POST' },
    { path: '/api/bookings/session-checkout', method: 'POST' },
    { path: '/api/checkout/session', method: 'POST' },
    { path: '/api/checkout/manual', method: 'POST' },
  ],
})
